"use client";

import { Translate } from "@/components/Translate";
import { ACCOUNT_PATHS } from "@/features/account/config";
import { useLoyaltyProfile } from "@/features/loyalty/hooks";
import { Link } from "@/i18n/Link";
import { useFlag } from "@/lib/flags/client";
import { useUser } from "@frend-digital/centra/client";
import styles from "./Snackbar.module.css";

export const SnackbarPoints = () => {
	const { data: user } = useUser();
	const loyaltyEnabled = useFlag("loyalty.enabled");

	// Only mount the value below (and its useLoyaltyProfile query) once we know
	// there's a logged-in user, so anonymous visitors don't fire a loyalty request.
	if (!user || !loyaltyEnabled) return null;

	return <SnackbarPointsValue />;
};

const SnackbarPointsValue = () => {
	const { data: loyaltyProfile } = useLoyaltyProfile();

	if (!loyaltyProfile) return null;

	return (
		<>
			<span className={styles.divider} aria-hidden="true" />
			<Link href={ACCOUNT_PATHS.ROOT} className={styles.points}>
				<Translate>Bonus points</Translate>: {loyaltyProfile.points}
			</Link>
		</>
	);
};
